import { render, staticRenderFns } from "./AssessmentsIndex.vue?vue&type=template&id=45d74213&"
import script from "./AssessmentsIndex.vue?vue&type=script&lang=js&"
export * from "./AssessmentsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports